export default __webpack_public_path__ + "media/images/logo/sns/line-d2bac7db3051bb69e472c06195ccfe4d.png";